import { render, staticRenderFns } from "./intro-ctv.vue?vue&type=template&id=67319ab6&scoped=true"
var script = {}
import style0 from "./intro-ctv.vue?vue&type=style&index=0&id=67319ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67319ab6",
  null
  
)

export default component.exports